/* =========================================================================
   07 — FAQ accordion
   Drives open/close with an `is-open` class (animated via CSS
   grid-template-rows in acc_metallbude_lp_02_07.css) instead of the native
   <details> element, per CLAUDE.md §7 (no-animation gotcha).
   All lookups are scoped to this section's own root (`.acc-lp02-07`) —
   never `document.querySelector` against the wider theme DOM.
   ========================================================================= */
(function () {
  var roots = document.querySelectorAll('.acc-lp02-07');

  roots.forEach(function (root) {
    var items = root.querySelectorAll('.acc-lp02-07__item');

    items.forEach(function (item) {
      var question = item.querySelector('.acc-lp02-07__question');
      if (!question) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        item.classList.toggle('is-open', !isOpen);
        question.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });
})();
